import React from 'react';
import { connect } from 'react-redux';
import config from 'config';
import { getStatsDaily, getParams, findOccupancyTag, findEfficiencyTag } from 'actions/stats';
import { RECEIVE_FIRST_LOCATION_DAILY, RECEIVE_SECOND_LOCATION_DAILY } from 'actions/comparison';
import LineChart from 'components/common/charts/linechart';
import ModeSelector from 'components/common/dropdowncomponents/modeselector';
import TagSelector from 'components/common/dropdowncomponents/tagselector';
import DaySelector from 'components/common/dropdowncomponents/dayselector';
//import Modal from "components/common/modal";
export class DailyChart extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            mode: 'Average',
            tag: 'Occupancy',
            day: 'Mondays'
        };
    }
    // chooseTag locally changes tag inside this component, so whenever querySettings change -> setState of the tag
    // Or when the location changes from meeting room to open area which doesn't have efficiency tag -> setState of the tag
    componentWillReceiveProps(nextProps) {
        if (nextProps.isMeetingRoom !== this.props.isMeetingRoom ||
            nextProps.querySettings != this.props.querySettings) {
            this.setState({
                tag: 'Occupancy'
            })
        }
    }
    chooseDay(day) {
        this.setState({ day: day });
    }

    chooseMode(mode) {
        this.setState({ mode: mode });
    }

    chooseTag(tag) {
        this.setState({ tag: tag });
        let params = getParams({ querySettings: this.props.querySettings, currentNode: this.props.first });
        params.action = RECEIVE_FIRST_LOCATION_DAILY;
        let params1 = getParams({ querySettings: this.props.querySettings, currentNode: this.props.second });
        params1.action = RECEIVE_SECOND_LOCATION_DAILY;
        if (tag === 'Occupancy') {
            params.tag = findOccupancyTag(this.props.first);
            params1.tag = findOccupancyTag(this.props.second);
        }
        else {
            params.tag = findEfficiencyTag(this.props.first);
            params1.tag = findEfficiencyTag(this.props.second);
        }
        this.props.dispatch(getStatsDaily(params));
        this.props.dispatch(getStatsDaily(params1));
    }

    sortUnique(arr) {
        if (arr.length === 0) return arr;
        var srt = arr.sort(function (a, b) { return a * 1 - b * 1; });
        var ret = [srt[0]];
        for (var i = 1; i < srt.length; i++) { //Start loop at 1: arr[0] can never be a duplicate
            if (srt[i - 1] !== srt[i]) {
                ret.push(srt[i]);
            }
        }
        return ret;
    }

    getLineChartData() {
        let mode = this.state.mode == 'Average' ? 'avg' : 'pk';
        let data = {
            labels: [],
            peaks: [],
            avgs: []
        }
        if (this.props.stats.length == 2 && this.props.stats[0] && this.props.stats[1]) {
            let first = this.props.stats[0].data.values[config.day.indexOf(this.state.day)];
            let second = this.props.stats[1].data.values[config.day.indexOf(this.state.day)];
            var k1 = Object.keys(first ? first : []).map(x => parseInt(x));
            var k2 = Object.keys(second ? second : []).map(x => parseInt(x));
            var hours = this.sortUnique(k1.concat(k2)).map(x => x + "");

            hours.forEach(hour => {
                data.labels.push(hour);
                if (second[hour] && second[hour][mode] >= 0) {
                    data.avgs.push(Math.round(second[hour][mode] * 100));
                } else {
                    data.avgs.push(null);
                }
                if (first[hour] && first[hour][mode] >= 0) {
                    data.peaks.push(Math.round(first[hour][mode] * 100));
                } else {
                    data.peaks.push(null);
                }
            });
        }
        return data;
    }

    render() {
        let data = this.getLineChartData();
        let first = '';
        let second = '';
        if (this.props.first.info && this.props.first.info) {
            first = this.props.first.info.name;
            second = this.props.second.info.name;
        }
        return (
            <div className="stats-card">
                <div className="box--shadow bg--white card__graph">
                    <div className="clearfix graph__header">
                        <h2 className="graph__header__title graph__header__title--comparison-title pull-left">{this.state.tag} Daily Comparison</h2>
                        <div className="graph__header__options pull-right clearfix">
                            <div className="header__options__child pull-left"><DaySelector day={this.state.day} chooseDay={this.chooseDay.bind(this)} items={config.day} /></div>
                            <div className="header__options__child pull-left"><ModeSelector mode={this.state.mode} chooseMode={this.chooseMode.bind(this)} /></div>
                            {this.props.isMeetingRoom &&
                                <div className="header__options__child pull-left"><TagSelector roomType="meeting_room" tag={this.state.tag} chooseTag={this.chooseTag.bind(this)} /></div>
                            }
                            {/*  <Modal
                                disableCloseButton={true}
                                ref={(elem) => { this.openInfoModal = elem }}
                                clickButton={() => { this.openInfoModal.close(); }}
                                header="Info Modal"
                                buttonText="Got it"
                                buttonClass="btn-success"
                                entry={
                                    <div className="header__options__child pull-left">
                                        <div onClick={() => { this.openInfoModal.open() }} className="">
                                            <img className="card-info cursor--pointer" src="src/assets/icons/info.svg" alt="info-icon" />
                                        </div>
                                    </div>
                                }
                            >
                                <p>Daily comparsion Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                            </Modal>      */}
                        </div>
                    </div>
                    <div className="graph__body  clearfix">
                        <LineChart id="dailycomparison" stats={data} first={first} second={second} />
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(null, mapDispatchToProps)(DailyChart);


// WEBPACK FOOTER //
// ./src/components/pages/comparison/charts/dailychart/index.jsx